export default __webpack_public_path__ + "a2501516a5770b50a4f0eb2ed36bf08e.svg";